import IMask from 'imask/esm/imask';

function fireEvent(el, eventName, data) {
  const e = document.createEvent('CustomEvent');
  e.initCustomEvent(eventName, true, true, data);
  el.dispatchEvent(e);
}
function initMask(el, opts) {
  const maskRef = opts instanceof IMask.InputMask ? opts : IMask(el, opts);
  return maskRef.on('accept', () => fireEvent(el, 'accept', maskRef)).on('complete', () => fireEvent(el, 'complete', maskRef));
}
function IMaskAction(el, opts) {
  let maskRef;
  let created;
  function destroy() {
    var _maskRef;
    if (created) (_maskRef = maskRef) == null || _maskRef.destroy();
    maskRef = undefined;
    created = undefined;
  }
  function update(opts) {
    if (!opts) return destroy();
    if (opts instanceof IMask.InputMask || !maskRef) maskRef = initMask(el, opts);else maskRef.updateOptions(opts);
    created = opts !== maskRef;
  }
  update(opts);
  return {
    update,
    destroy
  };
}

export { IMaskAction as default };
